/* so-cart-delivery — opens the "How delivery is priced" modal from the cart delivery row.
   The row is re-rendered by the theme on every cart change, so everything is delegated from
   document and the modal is cloned fresh from the row's <template> each time it opens (it always
   carries the current figures). The modal is portalled to <body> so the drawer re-render can't
   remove it mid-read. Escape is handled in the capture phase so it closes the modal only, not the
   cart drawer behind it.
   With so-postcode.js and the page delivery config present, every [data-so-cd-open] click (the Liquid row,
   "See delivery prices for your postcode", the failed/empty "Change") is taken over there, in the capture
   phase, and opens the shared postcode/delivery sheets instead; this modal is the fallback without them.
   2026-09-29 site overlay standard: the modal is the shared .so-dsheet shell (so-delivery-sheet.css) — a bottom sheet
   with swipe-down (window.soSheetSwipe) on phones, a centred dialog from 768px; .is-open drives its motion. */
(function () {
  if (window.soCartDeliveryBound) return;
  window.soCartDeliveryBound = true;

  var openModal = null;
  var opener = null;
  var saved = null;

  // Scroll lock: the page AND the drawer's own item list must stay put while the modal is open.
  // body/html overflow covers the page; wheel/touchmove outside the modal window are blocked for
  // the drawer's scroll container. Previous inline styles are restored exactly on close, because
  // the drawer applies its own lock and we must not clear it.
  function blockOutside(e) {
    if (!openModal) return;
    var win = openModal.querySelector('.so-dsheet__panel');
    if (win && win.contains(e.target)) return;
    e.preventDefault();
  }
  function lockScroll() {
    saved = { html: document.documentElement.style.overflow, body: document.body.style.overflow };
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';
    document.addEventListener('wheel', blockOutside, { passive: false, capture: true });
    document.addEventListener('touchmove', blockOutside, { passive: false, capture: true });
  }
  function unlockScroll() {
    if (!saved) return;
    document.documentElement.style.overflow = saved.html;
    document.body.style.overflow = saved.body;
    saved = null;
    document.removeEventListener('wheel', blockOutside, { capture: true });
    document.removeEventListener('touchmove', blockOutside, { capture: true });
  }

  function close() {
    if (!openModal) return;
    var m = openModal;
    m.classList.remove('is-open');
    m.classList.add('is-closing');
    setTimeout(function () { m.remove(); }, 260);   // let the sheet slide / fade out
    openModal = null;
    unlockScroll();
    var back = opener && opener.isConnected ? opener : document.querySelector('[data-so-cd-open]');
    opener = null;
    if (back) back.focus({ preventScroll: true });
  }

  function open(btn) {
    var host = btn.closest('[data-so-cart-delivery]');
    var tpl = host && host.querySelector('template[data-so-cd-modal]');
    if (!tpl) return;
    close();
    var modal = tpl.content.firstElementChild.cloneNode(true);
    document.body.appendChild(modal);
    modal.hidden = false;
    openModal = modal;
    opener = btn;
    lockScroll();
    var panel = modal.querySelector('.so-dsheet__panel');
    if (window.soSheetSwipe && panel) {
      window.soSheetSwipe.attach(panel, {
        handle: '.so-dsheet__grab, .so-dsheet__head', scroller: '.so-dsheet__body',
        backdrop: modal.querySelector('.so-dsheet__backdrop'), onClose: function () { if (openModal === modal) close(); }
      });
    }
    void modal.offsetWidth;                 // reflow, then slide in
    modal.classList.add('is-open');
    var win = modal.querySelector('.so-dsheet__title');
    if (win) win.focus({ preventScroll: true });
    // so-postcode.js fills the postcode section (and may move focus to its input).
    document.dispatchEvent(new CustomEvent('so:cd-modal-open', { detail: { modal: modal, block: host, focus: btn.getAttribute('data-so-cd-focus') } }));
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-so-cd-open]');
    if (btn) {
      e.preventDefault();
      open(btn);
      return;
    }
    if (openModal && e.target.closest('[data-so-close]') && openModal.contains(e.target)) {
      e.preventDefault();
      close();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (!openModal) return;
    if (e.key === 'Escape') {
      e.preventDefault();
      e.stopPropagation();
      close();
    } else if (e.key === 'Tab') {
      // Trap focus inside the modal: it can now hold the postcode input and button, not just "close".
      var f = Array.prototype.filter.call(openModal.querySelectorAll('button, input, a[href], [tabindex]:not([tabindex="-1"])'), function (el) { return !el.disabled && el.offsetParent !== null; });
      if (!f.length) { e.preventDefault(); return; }
      var i = f.indexOf(document.activeElement);
      var to = e.shiftKey ? (i <= 0 ? f[f.length - 1] : f[i - 1]) : (i === -1 || i === f.length - 1 ? f[0] : f[i + 1]);
      e.preventDefault(); to.focus();
    }
  }, true);

  // Keep focus inside the modal if the drawer's own focus handling tries to pull it back.
  document.addEventListener('focusin', function (e) {
    if (openModal && !openModal.contains(e.target)) {
      var win = openModal.querySelector('.so-dsheet__title');
      if (win) win.focus({ preventScroll: true });
    }
  }, true);
  // Mixed pre-order carts: "Remove the pre-order items" (value "shipnow") trims the cart at checkout,
  // so show the in-stock-only copy of the delivery row while it is selected.
  document.addEventListener('change', function (e) {
    var r = e.target;
    if (!r || !r.classList || !r.classList.contains('so-preorder-cart__radio')) return;
    var scope = r.closest('.cart-drawer__checkout-buttons, .cart__checkout-buttons') || document;
    var useShipnow = r.value === 'shipnow' && r.checked;
    scope.querySelectorAll('[data-so-cd-variant]').forEach(function (el) {
      el.hidden = useShipnow ? el.getAttribute('data-so-cd-variant') !== 'shipnow' : el.getAttribute('data-so-cd-variant') !== 'all';
    });
  });
})();
